import Image from 'next/image';
import { TypeformButtonMain } from '../../components';
import Layout from '../../ui/layout';
import Carousel from '../../ui/carousel';
import { Wrap, ButtonInverted } from '../../styled';
import {
  H2,
  Text,
  Container,
  MobileOnly,
  DesktopOnly,
  IntroContainer,
  Intro,
  IntroBackground,
  IntroBackgroundImageContainer,
  IntroInner,
  IntroHeading,
  IntroDescription,
  EcommerceTechLogoContainer,
  EcommerceTechLogo,
  EcommerceTechLogoTitle,
  BrandsList,
  BrandLogo,
  Card,
  CardItem,
  CardTitle,
  Section,
  FeaturesList,
  FeaturesListItem,
  FeaturesListItemText,
  KpiContainer,
  KpiStats,
  KpiImage,
  KpiList,
  KpiListItem,
  AdvantagesText,
  IntegrationTextContainer,
  IntegrationTextContainerItem,
  IntegrationTextTitle,
  IntegrationTextGroup,
  IntegrationTextItem,
} from './styled';
import ecommerceTechLogo from './images/ecommerce-tech.svg';
import widgetImage from './images/widget.jpg';
import shopifyLogo from './images/shopify.svg';
import shopifyPlusLogo from './images/shopify-plus.svg';
import customHtmlLogo from './images/custom-html-tag.svg';
import googleTagManagerLogo from './images/google-tag-manager.svg';
import kpiImage from './images/kpi.jpg';
import advantages from './advantages';
import brands from './brands';
import integrations from './integrations';
import kpi from './kpi';
import slides from './slides';

function EcommerceTech() {
  return (
    <Layout>
      <Container>
        <IntroContainer>
          <IntroBackground>
            <IntroBackgroundImageContainer>
              <Image
                src={widgetImage}
                alt=""
                fill
                style={{
                  objectFit: 'contain',
                  objectPosition: 'right',
                }}
                priority
              />
            </IntroBackgroundImageContainer>
          </IntroBackground>
          <Wrap>
            <Intro>
              <EcommerceTechLogoContainer>
                <EcommerceTechLogo>
                  <Image src={ecommerceTechLogo} alt="Ecommerce Tech logo" />
                </EcommerceTechLogo>
                <EcommerceTechLogoTitle>
                  Official Partner
                </EcommerceTechLogoTitle>
              </EcommerceTechLogoContainer>
              <IntroInner>
                <IntroHeading>SIZE-AS-A-SERVICE</IntroHeading>
                <IntroDescription>
                  Next generation AI Sizing Software for Apparel Retailers
                </IntroDescription>
                <ButtonInverted as={TypeformButtonMain}>
                  Shedule a demo
                </ButtonInverted>
              </IntroInner>
            </Intro>
            <MobileOnly>
              <Image src={widgetImage} alt="" />
            </MobileOnly>
          </Wrap>
        </IntroContainer>
        <Section>
          <Wrap>
            <H2>
              You’re in <span>good company</span>
            </H2>
            <BrandsList>
              {brands.map(({ name, logo }) => (
                <li key={name}>
                  <BrandLogo>
                    <Image src={logo} alt={name} />
                  </BrandLogo>
                </li>
              ))}
            </BrandsList>
            <Text>
              Join hundreds of brands globally with our award-winning platform
            </Text>
            <ButtonInverted as={TypeformButtonMain}>
              Shall we talk?
            </ButtonInverted>
          </Wrap>
        </Section>
        <Section backgroundFill>
          <Wrap>
            <H2>
              What We <span>Provide</span>
            </H2>
            <FeaturesList>
              {advantages.map(({ icon, text }) => (
                <FeaturesListItem key={text}>
                  <Image src={icon} alt="" />
                  <FeaturesListItemText>{text}</FeaturesListItemText>
                </FeaturesListItem>
              ))}
            </FeaturesList>
          </Wrap>
          <MobileOnly>
            <Carousel
              {...{
                arrows: true,
                fade: true,
              }}
            >
              {slides.map(({ name, mobile }) => (
                <div key={name}>
                  <Image src={mobile} alt="" />
                </div>
              ))}
            </Carousel>
          </MobileOnly>
          <DesktopOnly>
            <Carousel
              {...{
                arrows: true,
                fade: true,
              }}
            >
              {slides.map(({ name, desktop }) => (
                <div key={name}>
                  <Image src={desktop} alt="" />
                </div>
              ))}
            </Carousel>
          </DesktopOnly>
          <Wrap>
            <AdvantagesText>
              Increase your AOV, conversion rates, customer satisfaction and
              loyalty while reducing your return rates
            </AdvantagesText>
            <ButtonInverted as={TypeformButtonMain}>
              See a live demo
            </ButtonInverted>
          </Wrap>
        </Section>
        <Section>
          <Wrap>
            <KpiContainer>
              <KpiStats>
                <H2>KPIs</H2>
                <KpiList>
                  {kpi.map(({ text, value }) => {
                    const isNegative = value.startsWith('-');

                    return (
                      <KpiListItem key={text} rotateIcon={isNegative}>
                        {text}{': '}
                        <strong>{value}</strong>
                      </KpiListItem>
                    );
                  })}
                </KpiList>
              </KpiStats>
              <KpiImage>
                <Image src={kpiImage} alt="" />
              </KpiImage>
            </KpiContainer>
          </Wrap>
        </Section>
        <Section backgroundFill>
          <Wrap>
            <H2>Integrations</H2>
            <Text>
              EyeFitU’s SizeEngine™ seamlessly integrates into all e-commerce
              platforms and POS systems
            </Text>
            <FeaturesList>
              {integrations.map(({ icon, text }) => (
                <FeaturesListItem key={text}>
                  <Image src={icon} alt="" />
                  <FeaturesListItemText>{text}</FeaturesListItemText>
                </FeaturesListItem>
              ))}
            </FeaturesList>
            <IntegrationTextContainer>
              <IntegrationTextContainerItem>
                <Text>
                  <IntegrationTextTitle>Available App on</IntegrationTextTitle>
                  <IntegrationTextGroup>
                    <a
                      href="https://apps.shopify.com/eyefitu-widget"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image src={shopifyLogo} alt="shopify logo" width={220} />
                    </a>
                    <IntegrationTextItem>and</IntegrationTextItem>
                    <a
                      href="https://apps.shopify.com/eyefitu-widget"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src={shopifyPlusLogo}
                        alt="shopify plus logo"
                        width={220}
                      />
                    </a>
                  </IntegrationTextGroup>
                </Text>
              </IntegrationTextContainerItem>
              <IntegrationTextContainerItem>
                <Text>
                  <IntegrationTextTitle>Available as</IntegrationTextTitle>
                  <IntegrationTextGroup>
                    <Image
                      src={customHtmlLogo}
                      alt="Custom HTML Tag logo"
                      width={220}
                    />
                    <IntegrationTextItem>with</IntegrationTextItem>
                    <Image
                      src={googleTagManagerLogo}
                      alt="Google Tag Manager logo"
                      width={220}
                    />
                  </IntegrationTextGroup>
                </Text>
              </IntegrationTextContainerItem>
            </IntegrationTextContainer>
            <Card>
              <CardItem>
                <CardTitle>Sign up for a free demo</CardTitle>
              </CardItem>
              <CardItem>
                <ButtonInverted as={TypeformButtonMain}>
                  Book now
                </ButtonInverted>
              </CardItem>
            </Card>
          </Wrap>
        </Section>
      </Container>
    </Layout>
  );
}

export default EcommerceTech;
